import React, { useEffect, useRef, useState } from 'react';
import { Switch } from '@consta/uikit/Switch';
import { Item, Tabs } from '@ui/tabs';
import { Loader } from '@ui/loader';
import { useStore } from '@lib/state-engine';
import { dateFormatter, DATE_TIME_FORMAT } from '@lib/date-formatting';
import { WarehouseSleeveBadge, WarehouseStationaryBadge } from '@ui/icons';
import { warehouseModel } from '@entities/warehouse';
import { RemoveWarehouse } from '@features/remove-warehouse';
import { BagsList } from '../bags-list';
import {
  $selectedWarehouseId,
  $zoomModeEnabled,
  selectWarehouse,
  toggleZoomMode,
} from '../model';

import styles from './styles.module.sass';
import ContentEditable, { ContentEditableEvent } from 'react-contenteditable';
import { DiContainer } from '@@/di/di-container';
import { WarehousesService } from '@@/warehouses/services/warehouses.service';
import { responseErrorInterceptorNotification } from '@@/common/utils/response-error-interceptor-notification.util';

import { Statistic } from '@widgets/storage-viewer/warehouse-detalization/statistic';
import { FillBagModal } from '@@/bags/components/fill-bag-modal';
import {
  $agricultureModalIdEnable,
  $copiedBagParamsBuffer,
  closeAgricultureModal,
  copySleeveParams,
} from '@@/agriculture/store/agriculture.store';
import {
  $warehouseStatistic,
  fetchWarehouseStatByIdFx,
  WAREHOUSE_TYPES,
} from '@/entities/warehouse/store';
import { $userPermissions } from '@/modules/auth/store/auth.store';
import { MODES, setViewMode } from '@/features/storage-mode-select/model';

const warehousesService = DiContainer.get(WarehousesService);

const TABS: Item[] = [
  { label: 'культуры', value: 'cultures' },
  { label: 'статистика', value: 'statistic' },
  { label: 'настройки', value: 'settings' },
];

export const WarehouseDetalization = () => {
  const [activeTab, setActiveTab] = useState(TABS[0].value);
  const permissions = useStore($userPermissions);

  const warehouseId = useStore($selectedWarehouseId);
  const selectedWarehouse = useStore(warehouseModel.$warehouseInfo);
  const isLoadingWarehouse = useStore(warehouseModel.$isLoadingWarehouseInfo);
  const zoomMode = useStore<boolean>($zoomModeEnabled);
  const copiedBagParamsBuffer = useStore($copiedBagParamsBuffer);
  const showWarehouse = warehouseId && selectedWarehouse;
  const warehouseStatistic = useStore($warehouseStatistic);
  // const nameRef = useRef();
  let timeoutId = 0;
  const [agricultureModalIdEnable] = useStore($agricultureModalIdEnable);

  const licensesRemainder =
    typeof warehouseStatistic?.licence_count === 'number' &&
    typeof warehouseStatistic?.max_bags === 'number'
      ? warehouseStatistic.max_bags - warehouseStatistic.licence_count
      : '_';
  const onNameMutation = (newName: ContentEditableEvent) => {
    clearTimeout(timeoutId);
    timeoutId = setTimeout(async () => {
      if (!selectedWarehouse) return;
      responseErrorInterceptorNotification({
        handler: () =>
          warehousesService
            .rename(newName.target.value, Number(selectedWarehouse.id))
            .then((editedName) => {
              selectedWarehouse.name =
                typeof editedName == 'string' ? editedName : editedName.name;
            }),
        catchHandler: (err, isResponse, body) => {
          throw err; // чтобы effector не считал, что эффект завершился успешно
        },
      });
    }, 1000);
  };
  //Проверка на то чтобы сохроненый склад при выключеном погле был стационарным
  const inspectionWarehouse = permissions.storage || selectedWarehouse?.type === 1;
  useEffect(() => {
    fetchWarehouseStatByIdFx(Number(warehouseId));
  }, []);
  return (
    <div className={styles.container}>
      {/* <ButtonClose
        className={styles.close}
        onClick={() => toggleDetalizationPanel(!detalizationOpened)}
      /> */}
      {isLoadingWarehouse ? (
        <Loader />
      ) : inspectionWarehouse && showWarehouse ? (
        <>
          <div className={styles.header}>
            {selectedWarehouse.type === warehouseModel.WAREHOUSE_TYPES.sleeve && (
              <>
                <WarehouseSleeveBadge />
                <Switch
                  label="Zoom на карте"
                  className={styles.zoom}
                  checked={zoomMode}
                  onChange={(e) => {
                    if (!e.checked) {
                      setViewMode(MODES[1].value);
                    }
                    toggleZoomMode(e.checked);
                  }}
                />
              </>
            )}
            {selectedWarehouse.type === warehouseModel.WAREHOUSE_TYPES.stationary && (
              <WarehouseStationaryBadge />
            )}
            <h1 className={styles.title}>
              {selectedWarehouse.name ? selectedWarehouse.name?.toString() : ''}
            </h1>
          </div>
          <p className={styles.location}></p>
          <dl className={styles.generalParams}>
            <dt>общий вес:</dt>
            {selectedWarehouse.totalWeight ? (
              <dd>
                {Number(selectedWarehouse.totalWeight).toLocaleString('RU-ru', {
                  maximumFractionDigits: 1,
                })}{' '}
                т
              </dd>
            ) : (
              <dd>0 т</dd>
            )}
            <dt>создан:</dt>
            <dd>
              {dateFormatter(selectedWarehouse.createdAt).format(DATE_TIME_FORMAT)}
            </dd>
            {selectedWarehouse.type === WAREHOUSE_TYPES.sleeve && (
              <>
                {' '}
                <dt>длина рукава:</dt>
                <dd>
                  {selectedWarehouse.bagsSize && `${selectedWarehouse.bagsSize} м`}
                </dd>
              </>
            )}
          </dl>
          {copiedBagParamsBuffer &&
            copiedBagParamsBuffer.warehouseId === warehouseId && (
              <div className={styles.copiedParams}>
                <>
                  {selectedWarehouse.type === warehouseModel.WAREHOUSE_TYPES.stationary
                    ? 'Объём'
                    : 'Рукав'}{' '}
                  №{copiedBagParamsBuffer.id} скопирован в буфер обмена
                  <a href="#" onClick={() => copySleeveParams(null)}>
                    очистить
                  </a>
                </>
              </div>
            )}
          <Tabs
            className={styles.tabs}
            active={activeTab}
            items={TABS}
            onChange={(v) => setActiveTab(v)}
          />
          {activeTab === 'cultures' && (
            <>
              <dl className={styles.bagParams}>
                <dt>
                  {selectedWarehouse.type === WAREHOUSE_TYPES.sleeve
                    ? 'всего рукавов на складе:'
                    : 'всего:'}
                </dt>
                <dd>
                  {selectedWarehouse.totalBags} ({selectedWarehouse.filledBags}{' '}
                  заполнено)
                </dd>
                {selectedWarehouse.type === warehouseModel.WAREHOUSE_TYPES.sleeve && (
                  <dt>доступно рукавов по лицензии:</dt>
                )}
                {+licensesRemainder >= 0 && <dd>{licensesRemainder}</dd>}
              </dl>

              <BagsList warehouseType={selectedWarehouse.type} />
            </>
          )}
          {activeTab === 'settings' && (
            <div>
              <RemoveWarehouse
                id={selectedWarehouse.id}
                warehouseType={selectedWarehouse.type}
              />
            </div>
          )}
          {activeTab === 'statistic' && (
            <div className={styles.statsData}>
              <Statistic />
            </div>
          )}
          {agricultureModalIdEnable && (
            <FillBagModal
              id={agricultureModalIdEnable}
              onClose={() => closeAgricultureModal()}
            />
          )}
        </>
      ) : (
        <p className={styles.noWh}>Пожалуйста, выберите склад</p>
      )}
    </div>
  );
};
